import React, { useEffect, useRef, useState } from 'react';
import './CollectionSection.css';
import { FaArrowRight } from 'react-icons/fa';
import { collection, onSnapshot, query, limit, orderBy } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase/firebase-config';

const CollectionSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const q = query(
      collection(db, "categories"), 
      orderBy("createdAt", "desc"), 
      limit(4)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCategories(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (loading || categories.length === 0) return;

    const scrollContainer = scrollRef.current;
    let requestAnimationFrameId;
    let isPaused = false; 
    
    const scroll = () => {
      if (scrollContainer && !isPaused) {
        scrollContainer.scrollLeft += 0.8;
        if (scrollContainer.scrollLeft >= (scrollContainer.scrollWidth / 2)) {
          scrollContainer.scrollLeft = 0;
        }
      }
      requestAnimationFrameId = requestAnimationFrame(scroll);
    };

    // Etkileşim durumunda duraklatma (Mobilde çakışmaması için şart)
    const handlePause = () => { isPaused = true; };
    const handleResume = () => { isPaused = false; };

    if (scrollContainer) {
      scrollContainer.addEventListener('mouseenter', handlePause);
      scrollContainer.addEventListener('mouseleave', handleResume);
      scrollContainer.addEventListener('touchstart', handlePause);
      scrollContainer.addEventListener('touchend', handleResume);
    }

    requestAnimationFrameId = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(requestAnimationFrameId);
      if (scrollContainer) {
        scrollContainer.removeEventListener('mouseenter', handlePause);
        scrollContainer.removeEventListener('mouseleave', handleResume);
        scrollContainer.removeEventListener('touchstart', handlePause);
        scrollContainer.removeEventListener('touchend', handleResume);
      }
    };
  }, [loading, categories]);

  if (loading) return <div className="loading-placeholder">Koleksiyon Hazırlanıyor...</div>;

  return (
    <section className="collections-section">
      <div className="section-container">
        
        <div className="collection-info">
          <span className="section-subtitle">Sanatı Keşfet</span>
          <h2 className="section-title">Nadir <br /> <em>Parçalar</em></h2>
          <p className="section-desc">
            Tesbihçimen olarak, her bir tanesinde ruh barındıran, 
            mezat kültürünün en nadide örneklerini bir araya getirdik. 
          </p>
          <button onClick={() => navigate('/urunler')} className="explore-link-btn">
            Tüm Koleksiyonu Gör <FaArrowRight className="arrow-icon-right" />
          </button>
        </div>

        <div className="collection-grid" ref={scrollRef}>
          {[...categories, ...categories].map((item, index) => (
            <div key={`${item.id}-${index}`} className="collection-card">
              <div className="card-inner-wrapper">
                <div className="card-image-box">
                  <img src={item.coverImg} alt={item.title} className="parallax-img" />
                </div>
                <div className="card-text-content">
                  <h3>{item.title}</h3>
                  <div className="card-line"></div>
                  <p>En nadide {item.title} eserlerini keşfedin.</p>
                  <button 
                    className="card-details-btn"
                    onClick={() => navigate(`/kategori/${item.slug}`)}
                  >
                    İncele
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CollectionSection;